export class VideoInfo {
    menuOpen: boolean;

    handleMenuClick(videoId: string, element: HTMLElement) {
        if (this.menuOpen) {
            this.closeMenu();
            return;
        }

        show_items_menu(videoId, element);
        this.menuOpen = true;
    }

    closeMenu() {
        this.menuOpen = false;
    }
}
